<template>
  <div class="content_view">
    <div class="main" v-if="isVip == true">
      <ul class="category">
        <li>
          <p>完成任务数</p>
          <h2>{{ countData.doneCount || 0 }}</h2>
        </li>
        <li>
          <p>总学员数</p>
          <h2>{{ countData.studengCount || 0 }}</h2>
        </li>
        <li>
          <p>学习记录</p>
          <h2>{{ countData.learnCount || 0 }}</h2>
        </li>
      </ul>
      <div class="charts_view">
        <!-- 折线图 -->
        <div class="broken_charts">
          <div class="broken_chang">
            <el-date-picker
              v-model="value1"
              @change="fn"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
          </div>
          <div ref="broken" :key="echarkey" style="height: 460px"></div>
        </div>

        <!-- 环形图 -->
        <div class="circular">
          <div class="circular_hader">
            <h2>任务总数</h2>
            <p>{{ countData.allmission || 0 }}</p>
          </div>
          <!-- 环形 -->
          <div class="circular_view">
            <div>
              <radial
                :percentNum="percentNum"
                speed="3"
                size="155"
                color="#0052D9"
                backgroundColor="#BAC4D1"
                content="完成占比"
              />
              <div class="prompt_view">
                <div>
                  <p class="default_color"></p>
                  <p>已完成</p>
                </div>
                <div>
                  <p class="selected_color"></p>
                  <p>未完成</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 排名学分表格 -->
      <div class="ranking_table">
        <div class="complete_table">
          <div class="table_title">
            <p>完成数排名</p>
            <div class="switch_view">
              <div
                :class="completeSelected == 0 ? 'hover' : ''"
                @click="switchState('完成数', 0)"
              >
                总数
              </div>
              <div
                :class="completeSelected == 1 ? 'hover' : ''"
                @click="switchState('完成数', 1)"
              >
                本周
              </div>
            </div>
          </div>
          <div v-loading="loading">
            <el-table
              :data="completeTableData"
              style="width: 100%"
              height="250"
            >
              <el-table-column label="排名" width="100">
                <template slot-scope="scope">
                  <div
                    :class="scope.$index + 1 <= 3 ? 'ball_blue' : 'ball_view'"
                  >
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="RealName" label="学员名称">
              </el-table-column>
              <el-table-column prop="doneCount" label="完成数">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="credit_table">
          <div class="table_title">
            <p>获得学分排名</p>
            <div class="switch_view">
              <div
                :class="creditSelected == 0 ? 'hover' : ''"
                @click="switchState('学分', 0)"
              >
                总数
              </div>
              <div
                :class="creditSelected == 1 ? 'hover' : ''"
                @click="switchState('学分', 1)"
              >
                本周
              </div>
            </div>
          </div>
          <div v-loading="loading2">
            <el-table :data="creditTableData" style="width: 100%" height="250">
              <el-table-column label="排名" width="50">
                <template slot-scope="scope">
                  <div
                    :class="scope.$index + 1 <= 3 ? 'ball_blue' : 'ball_view'"
                  >
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="RealName" label="学员名称">
              </el-table-column>
              <el-table-column prop="getScore" label="获得学分">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 完成数排名表格 -->
      <div class="all_table_view">
        <p>培训列表</p>
        <div class="all_table" v-loading="loading3">
          <el-table :data="tableData" height="350" border style="width: 100%">
            <el-table-column label="序号" width="100">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in formColumns"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              width="140"
            >
              <template slot-scope="scope">
                <div class="operation_box">
                  <el-button
                    type="text"
                    size="small"
                    @click="detailsTrainin(scope.row)"
                    >培训详情</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <Maskdomo v-else />
  </div>
</template>

<script>
import training from "@/api/trainingApi";
import { option } from "./charts";
import * as echarts from "echarts";
import radial from "./radial.vue";
import Maskdomo from "../../manage/components/Maskdomo.vue";

export default {
  data() {
    return {
      countData: "",
      rankData: "",
      echarkey: 1,
      myChartDom: "",
      value1: [],
      currentMonth: "",
      lastMonth: "",
      mouthData: [],
      percentNum: "",
      completeSelected: 1, // 0总数，1本周
      creditSelected: 1,
      completeTableData: [],
      creditTableData: [],
      loading: false,
      loading2: false,
      loading3: false,
      tableData: [],
      isVip: false,
      formColumns: [
        {
          prop: "name",
          label: "任务名称",
        },
        {
          prop: "trainStatus",
          label: "任务状态",
        },
        {
          prop: "begainTime1",
          width: "300px",
          label: "任务时间",
        },
        {
          prop: "missionCount",
          label: "任务数量",
        },
        {
          prop: "stuCount",
          label: "考生数量",
        },
        {
          prop: "doneCount",
          label: "已完成培训",
        },
      ],
    };
  },
  components: {
    radial,
    Maskdomo,
  },
  props: ["cutcoms"],
  methods: {
    async init() {
      // 查看是否有权限开通
      const { data } = await training.checkPower({});
      if (data.Status == 200) {
        this.isVip = data.Data.isOpenTrain;
        if (data.Data.isOpenTrain == true) {
          this.currentMonth = this.$moment().format("YYYY-MM"); // 例如 "2023-04"
          this.lastMonth = this.$moment()
            .subtract(1, "months")
            .format("YYYY-MM");
          this.value1[0] = this.lastMonth;
          this.value1[1] = this.currentMonth; // 默认
          console.log(this.currentMonth, this.lastMonth);
          this.getTrainingCount();
          this.dayCount();
        }
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
    },
    async getTrainingCount() {
      this.loading = true;
      this.loading2 = true;
      this.loading3 = true;
      const { data } = await training.trainingCount({});
      if (data.Status == 200) {
        this.countData = data.Data.countData;
        this.rankData = data.Data.rankData;
        this.completeTableData = this.rankData.doneCountWeek; // 默认本周
        this.creditTableData = this.rankData.scorCountWeek; // 默认本周
        this.tableData = data.Data.trainListData.map((item) => {
          item.begainTime1 =
            this.$moment(item.begainTime).format("YYYY-MM-DD") +
            "-" +
            this.$moment(item.endTime).format("YYYY-MM-DD");
          return item;
        });
        setTimeout(() => {
          this.loading = false;
          this.loading2 = false;
          this.loading3 = false;
        }, 500);
        if (data.Data.countData.allmission) {
          let a =
            (data.Data.countData.doneCount / data.Data.countData.allmission) *
            100;
          this.percentNum = a.toFixed(1);
        } else {
          this.percentNum = 0;
        }

        this.correctExamReturn();
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
      console.log(data);
    },
    fn() {
      this.dayCount();
      console.log(this.value1);
    },
    // 培训详情
    detailsTrainin(row) {
      this.$parent.examRow = row;
      this.$parent.type = 1;
      this.cutcoms(1);
    },
    switchState(name, type) {
      if (name == "完成数") {
        this.loading = true;
        this.completeSelected = type;
        if (type == 0) {
          // 总数
          this.completeTableData = this.rankData.doneCountAll;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.completeTableData = this.rankData.doneCountWeek;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        }
      } else {
        this.loading2 = true;
        this.creditSelected = type;
        if (type == 0) {
          // 总数
          this.creditTableData = this.rankData.scorCountAll;
          setTimeout(() => {
            this.loading2 = false;
          }, 500);
        } else {
          this.creditTableData = this.rankData.scorCountWeek;
          setTimeout(() => {
            this.loading2 = false;
          }, 500);
        }
      }
    },
    getMonthsInRange(startYear, startMonth, endYear, endMonth) {
      if (startMonth.indexOf("0") >= 0) {
        startMonth = startMonth;
      }
      if (endMonth.indexOf("0") >= 0) {
        endMonth = endMonth;
      }
      // 创建一个空数组来存储结果
      let months = [];

      // 计算起始和结束月份的日期对象
      let startDate = new Date(startYear, startMonth - 1, 1); // 月份是从0开始的，所以减1
      let endDate = new Date(endYear, endMonth, 0); // 月份的最后一天，所以设置为0

      // 当前日期设置为起始日期
      let currentDate = new Date(startDate);

      // 循环直到结束日期
      while (currentDate <= endDate) {
        // 将当前月份（格式为YYYY-MM）添加到数组中
        months.push(
          `${currentDate.getFullYear()}-${String(
            currentDate.getMonth() + 1
          ).padStart(2, "0")}`
        );
        // 设置下个月的第一天作为下一次循环的日期
        currentDate.setMonth(currentDate.getMonth() + 1, 1);
      }

      return months;
    },
    async dayCount() {
      const obj = {
        begainTime: this.$moment(this.value1[0]).format("YYYY-MM"),
        endTime: this.$moment(this.value1[1]).format("YYYY-MM"),
      };
      const { data } = await training.dayCount(obj);
      if (data.Status == 200) {
        // this.countData = data.Data.countData;
        const dom = this.$refs.broken;
        this.myChartDom = echarts.init(dom);
        const startYear = obj.begainTime.substr(0, 4);
        const startMonth = obj.begainTime.substr(5, 2);
        const endYear = obj.endTime.substr(0, 4);
        const endMonth = obj.endTime.substr(5, 2);
        option.xAxis.data = this.getMonthsInRange(
          startYear,
          startMonth,
          endYear,
          endMonth
        ); // 计算出X轴的默认数据
        this.mouthData = data.Data.mouthData;
        option.series = this.mouthData.map((item) => {
          const obj = {
            name: item.countDate,
            type: "line",
            stack: "Total",
            data: [],
          };

          obj.data = option.xAxis.data.map((zitem) => {
            console.log(item.countDate, zitem);
            if (item.countDate == zitem) {
              return item.doneCount;
            } else {
              return 0;
            }
          });
          return obj;
        });
        console.log(option.series, "mouthData");

        // option.
        // console.log(this.$moment(obj.endTime).daysInMonth());
        // currentMonth
        this.myChartDom.setOption(option);
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
    },
    // 批改试卷返回
    correctExamReturn() {
      if (this.$route.query.trainId) {
        const row = this.tableData.filter((item) => {
          return item.tranid == this.$route.query.trainId;
        });
        this.detailsTrainin(row[0]);
      } else {
        localStorage.removeItem("examRowTime");
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  //   height: 100%;
  min-height: 780px;
}
.category {
  display: flex;
  list-style-type: none;
  height: 160px;
  > li {
    flex: 1;
    // border: 1px solid #000;
    margin-right: 14px;
    text-align: center;
    padding: 40px 0px;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    box-shadow: 0 0 15px rgb(211, 210, 210);
    h2 {
      font-size: 34px;
      margin-top: 24px;
    }
    &:nth-child(1) {
      background: #0052d9;
      color: #fff;
    }
    &:nth-child(3) {
      margin-right: 0;
    }
  }
}
.charts_view {
  //   padding: 24px;
  padding-top: 24px;
  display: flex;
  .broken_charts {
    flex: 3;
    box-sizing: border-box;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    box-shadow: 0 0 15px rgb(211, 210, 210);
    margin-right: 24px;
    padding-top: 24px;
    position: relative;
    .broken_chang {
      position: absolute;
      z-index: 99;
      right: 4%;
      top: 4%;
    }
  }
  .circular {
    flex: 1;
    padding: 24px;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    box-shadow: 0 0 15px rgb(211, 210, 210);
  }
}
.circular_hader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > p {
    font-size: 22px;
  }
}
.circular_view {
  height: 100%;
  //   margin-top: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.prompt_view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 66px;
  > div {
    display: flex;
    align-items: center;
    font-size: 14px;
    &:nth-child(1) {
      margin-right: 24px;
    }
  }
  .default_color {
    width: 16px;
    height: 10px;
    background: #0052d9;
    margin-right: 4px;
  }
  .selected_color {
    width: 16px;
    height: 10px;
    background: #bac4d1;
    margin-right: 4px;
  }
}
.ranking_table {
  display: flex;
  margin-top: 24px;
  height: 400px;
  .table_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .switch_view {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        border: 1px solid #eeee;
        width: 80px;
        text-align: center;
        &:hover {
          border: 1px solid #0052d9;
          color: #0052d9;
        }
      }
    }
  }
  .complete_table {
    padding: 24px;
    flex: 1;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    // box-shadow: 0 0 15px rgb(211, 210, 210);
  }
  .credit_table {
    padding: 24px;
    flex: 1;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    // box-shadow: 0 0 15px rgb(211, 210, 210);
  }
}
.hover {
  border: 1px solid #0052d9 !important;
  color: #0052d9;
}
::v-deep .cell {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ball_view {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  font-size: 14px;
  background: #bcc4d0;
  color: #fff;
}
.ball_blue {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  font-size: 14px;
  color: #fff;
  background: #0052d9 !important;
}
.all_table_view {
  margin-top: 24px;
  padding: 24px;
}
.all_table {
  margin-top: 24px;
}
::v-deep .el-button--text {
  font-size: 16px;
}
::v-deep .el-range-separator {
  // color: #eeeeee !important;
  width: 50px;
}
</style>